var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "content-class": "v-modal-notification",
            "max-width": "350"
          },
          model: {
            value: _vm.vModel,
            callback: function($$v) {
              _vm.vModel = $$v
            },
            expression: "vModel"
          }
        },
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("v-card-text", [_vm._v(_vm._s(_vm.message))]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary darken-1", flat: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.handleClose($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("BTN_CANCEL")))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary darken-1", flat: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.handleConfirm($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("BTN_SAVE_WITHIN_VALIDATE")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e4b5540", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4b5540","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/modal-notification/template.html
// module id = null
// module chunks = 